import React from 'react';
import cx from 'classnames';

const CLASS_ROOT = 'dialog__content';

const DialogContent = ({ className, ...other }) => {
  const classes = cx(CLASS_ROOT, className);

  return <div className={classes} {...other} />;
};

DialogContent.displayName = 'DialogContent';

export default DialogContent;



// WEBPACK FOOTER //
// ./src/components/Dialog/DialogContent.js